// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "@/router";
import store from "@/store";
import "@/assets/styles/reset.scss";
import "@/assets/styles/common.scss";
import infiniteScroll from 'vue-infinite-scroll'
import Element from 'element-ui'

// import commonUtils from "@/assets/styles/common.scss";
Vue.config.productionTip = false;

// Vue.prototype.$commonUtils = commonUtils;

import Vant from "vant";
import "vant/lib/index.css";

Vue.use(Vant);
Vue.use(Element)
Vue.use(infiniteScroll)

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
